<template>
  <el-cascader
    v-model="value"
    placeholder=""
    :options="options"
    clearable
    filterable
    expand-trigger="hover"
    @change="handleChange">
  </el-cascader>
</template>

<script>
// TODO change API
import { queryCustomerList } from '@/api/place';

export default {
  model: {
    prop: 'site_id',
    event: 'change',
  },
  props: {
    site_id: {
      required: true,
    },
  },
  data() {
    return {
      value: [],
      options: [],
    };
  },
  watch: {
    site_id: {
      handler(val = '', oldVal) {
        this.value = val.split('_');
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      queryCustomerList().then((res) => {
        this.options = this.format(res.data);
      });
    },
    format(list) {
      if (!list || !list.length) {
        return [];
      }
      const options = [];
      list.forEach((item) => {
        const { brand, city, store, chinese_brand, chinese_city, chinese_store } = item;
        let brandOption = options.filter(b => b.value === brand)[0];
        // 找到对应的brand，若找不到则创建
        if (!brandOption) {
          brandOption = {
            value: brand,
            label: chinese_brand,
          };
          options.push(brandOption);
        }

        if (!brandOption.children) {
          brandOption.children = [];
        }
        // 找到对应的city，若找不到则创建
        let cityOption = brandOption.children.filter(c => c.value === city)[0];
        if (!cityOption) {
          cityOption = {
            value: city,
            label: chinese_city,
          };
          brandOption.children.push(cityOption);
        }

        if (!cityOption.children) {
          cityOption.children = [];
        }

        // 插入store，防止重复插入
        let storeOption = cityOption.children.filter(s => s.value === store)[0];
        if (!storeOption) {
          storeOption = {
            value: store,
            label: chinese_store,
          };
          cityOption.children.push(storeOption);
        }
      });
      return options;
    },
    handleChange() {
      this.$emit('change', this.value.join('_'));
    },
    reset() {
      this.value = [];
    },
  },
};
</script>
